import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMatchDisplayStore = defineStore('matchDisplay', () => {
  const fullscreen = ref(false)
  return { fullscreen }
})
